export default __webpack_public_path__ + "static/media/coder.64e477f3.svg";